module.exports = __webpack_public_path__ + "static/media/acc1.fb6037d2.jpg";